import React from 'react';

import type { OwnerParticipant } from '@/types/SixDetail.types';

import './ParticipantItem.scss';

interface ParticipantItemProps {
  participant: OwnerParticipant;
  role: 'Owner' | 'Internal' | 'External';
}

const INITIALS_LENGTH = 2;

const ParticipantItem: React.FC<ParticipantItemProps> = ({ participant, role }) => (
    <div className="participant-item">
      <div className="participant-item__avatar">
        {/* <div className="participant-avatar">{getInitials()}</div> */}
      </div>
      <div className="participant-item__info">
        <div className="participant-item__name">{participant.name}</div>
      </div>
      <div className="participant-item__role">
        <span className={`participant-badge participant-badge--${role.toLowerCase()}`}>
          {role}
        </span>
      </div>
    </div>
  );

export default ParticipantItem;
